// Product option modal — Location- and channel-aware price resolution for modifiers and service items.
import { getServiceItemAvailability } from '@core/utils/serviceItemStock';
import { firstNumber, getServiceItemDetails } from './normalize';

export function findLocationPriceSource(raw, locationId) {
  if (!Array.isArray(raw?.locations) || raw.locations.length === 0) return null;
  if (!locationId) return raw.locations[0];
  return raw.locations.find((location) => location?.location_id === locationId) ?? raw.locations[0];
}

export function findChannelPriceSource(location, channelId) {
  if (!Array.isArray(location?.channels) || location.channels.length === 0) return null;
  if (!channelId) return location.channels[0];
  return (
    location.channels.find((channel) => channel?.channel_id === channelId) ?? location.channels[0]
  );
}

export function getModifierDetails(option) {
  return option?.modifier_details ?? option?.modifierdetails ?? option;
}

export function resolveModifierOptionPrice(option, { locationId, channelId } = {}) {
  const details = getModifierDetails(option);
  const location = findLocationPriceSource(details, locationId);
  const channel = findChannelPriceSource(location, channelId);

  return firstNumber(channel?.price, 0) ?? 0;
}

export function resolveServiceItemPrice(item, { locationId, channelId } = {}) {
  const details = getServiceItemDetails(item);
  const location = findLocationPriceSource(
    details,
    item?.locationId ?? item?.location_id ?? locationId,
  );
  const channel = findChannelPriceSource(
    location,
    item?.channelId ?? item?.channel_id ?? channelId,
  );
  const serviceItemPriceDelta =
    firstNumber(
      item?.priceDelta,
      item?.price_delta,
      details?.priceDelta,
      details?.price_delta,
      0,
    ) ?? 0;
  const channelPrice =
    firstNumber(
      channel?.price,
      channel?.selling_price,
      channel?.priceDelta,
      channel?.price_delta,
      location?.price,
      details?.selling_price,
      details?.price,
      0,
    ) ?? 0;

  return serviceItemPriceDelta + channelPrice;
}

// Inactive / unavailable here, or out of stock: shown, but can't be picked.
export function isServiceItemSoldOut(item, opts = {}) {
  const { isAvailable, isOutOfStock } = getServiceItemAvailability(item, opts);
  return !isAvailable || isOutOfStock;
}
